import { gql } from '@apollo/client';

const CREATE_ACCESS_ACTIVITY_EVENT = gql`
  mutation createAccessActivityEvent($data: AccessActivityEventCreateInput!) {
    createAccessActivityEvent(data: $data)
  }
`;

export default CREATE_ACCESS_ACTIVITY_EVENT;
